/**
 * マイページ メニュー
 */
export interface MypageMenu {
  href: string;
  text: string;
}
export const mypageMenus: Array<MypageMenu> = [
  {
    href: "/mypage",
    text: "マイページ",
  },
  {
    href: "/purchase-histories",
    text: "予約一覧",
  },
  {
    href: "/mypage/messages",
    text: "メッセージ",
  },
  {
    href: "/mypage/accounts",
    text: "アカウント情報",
  },
  {
    href: "/mypage/credits",
    text: "支払い情報",
  },
  {
    href: "/mypage/password",
    text: "パスワード変更",
  },
];

/**
 * 最新の通知
 */
export interface NoticeProps {
  href: string;
  date: string;
  category: string;
  text: string;
}
